import type { DocumentError } from "@packages/commons";

export const applyLocalErrorsToSavedDocument = <TDocument extends { errors?: DocumentError[] }>(
  document: TDocument,
  errors: DocumentError[],
): TDocument => {
  return {
    ...document,
    errors,
  };
};

/**
 * Errors to restore when a rule document becomes clean again (eg the user undoes back to the saved contents).
 * The live compiler only runs on dirty documents, so without this the errors from the abandoned edit would remain.
 * Returns undefined when nothing needs to change, so callers don't dispatch (and re-trigger compilation) needlessly.
 */
export const getErrorsToRestoreWhenClean = (document: {
  isDirty: boolean;
  errors: DocumentError[];
  document?: { type?: string; errors?: DocumentError[] };
}): DocumentError[] | undefined => {
  if (document.isDirty || document.document?.type !== "ruledoc") return undefined;
  const savedErrors = document.document.errors ?? [];
  if (JSON.stringify(document.errors) === JSON.stringify(savedErrors)) return undefined;
  return savedErrors;
};
